import styled from 'styled-components'

export const CollapseWrapper = styled.div`
  ${({ wrapperStyle }) => wrapperStyle}
`
